import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

export default function CenteredProgress(props) {
    return (
        <Grid container spacing={3} style={{ textAlign: 'center' }}>
            <Grid item xs={12}>
                <CircularProgress style={{ marginTop: 4 }} size={ props?.size ? props.size : 40}></CircularProgress>
                {props.message ? (
                    <Typography variant="h6">{props.message}</Typography>
                ) : (
                    ''
                )}
            </Grid>
        </Grid>
    )
}
